/* ============================================================
   TAP TO BREW - Scroll Reveal
   .ttb-reveal 要素が画面に入ったら .is-visible を付与
   ============================================================ */
(function() {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.ttb-reveal').forEach(function(el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });

  document.querySelectorAll('.ttb-reveal').forEach(function(el) {
    observer.observe(el);
  });
})();
